import React, { useEffect, useState } from "react";
import styled from "styled-components";
import AppFull from '../assets/newSvg/appfull.webp'
import AppMo from '../assets/newSvg/appmo.webp'
import Download from '../assets/newSvg/download.svg'
import { Garanty } from "../components/Scomp/Garanty";
import { baseText } from "../Lang/fa/BaseText";
import BreadCromb from "../components/HomeComp/BreadCromb";
import PageTitlesFunc from "../components/Functions/PageTitlesFunc";

const StyleApp =styled.div`
    margin-top: calc(var(--top-gap) / 2);
    margin-bottom: 2rem;
    position: relative;
    min-height: 95vh;
    color: var(--text-2);
    display: flex;
    flex-direction: column;
    .top-app{
        display: flex;
        width: 100%;
        position: relative;
        flex-direction: column;
        .app-braed{
            margin-top: calc(var(--padding-top) / 1.5);
            z-index: 800;
            .bread-link{
                color: var(--text-3);
            }
        }
        .app-img{
            position: absolute;
            inset: 0;
            display: flex;
            object-fit: cover;
            width: 100%;
        }
        .app-tit{
            font-size: 1.5rem;
            font-weight: 700;
            color: var(--text-3);
            margin: 6rem auto 0;
            z-index: 800;
        }
        .app-desc{
            font-size: 1rem;
            font-weight: 500;
            color: var(--text-10);
            margin: auto;
            z-index: 800;
            width: 40%;
            text-align: center;
        }
        .app-dl-btn{
            position: relative;
            margin: 2rem auto 0;
            background-color: var(--body-2);
            padding: 0.78rem 1.8rem ;
            font-size: 0.87rem ;
            font-weight: 500;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            text-decoration: none;
            border-radius: var(--border-radius-4);
            color: var(--text-5);
        }
        .app-dl-icon{
            width: 1.5rem;
            aspect-ratio: 1;
            margin-left: 0.5rem;
        }
    }
    .app-garanty{
        display: flex;
        flex-direction: row;
        padding:2.5rem var(--padding) 1rem;
        width: calc(100% - var(--width-padding));
        margin-bottom: 1rem;
        margin-top: 30rem;
        .garant-title{
            top: 48rem;
        }
        .garant{
            .garanty-svg{
                width: 3rem;
            }
            .garanty-tit{
                font-size: 1.25rem;
            }
            .garanty-desc{
                font-size: 1rem;
            }
        }
    }
    @media screen and (max-width: 850px) {
        margin-top: 0;
        .top-app{
            .app-braed{
                margin-top: var(--padding-top);
            }
            .app-tit{
                margin-top: 2rem;
            }
            .app-desc{
                width: calc(100% - var(--width-padding));
            }
        }
    }
`
const Application =(props)=>{
    const [breadData , setBreadData]= useState([{ 
        name: '',
        link: ''
    }])
    useEffect(()=>{
        makeBreadCrombData()
        PageTitlesFunc({
            title : ' نرم افزار- لوکسین لوکس '   , 
            description: baseText.app, 
            canonical: 'https://' + window.location.hostname + '/application/'
        })
    },[])
    const makeBreadCrombData = ()=> {
        let mainName = 'خانه';
        let startLink = '/';
        let breadData = [
            {
                name: mainName,
                link: startLink
            },
        ]
        if(props.match.path=== '/application'){
            breadData.push(
                {
                    name: 'نرم افزار',
                    link: '/application/'
                }
            )
        }
        setBreadData(breadData)
    }
// console.log(breadData)
    return(
        <StyleApp>
            <div className="top-app">
                <BreadCromb data={breadData} classname='app-braed'/>
                <img className="app-img" alt="app-img" src={window.innerWidth > 850 ? AppFull : AppMo}/>
                <span className="app-tit">اپلیکیشن لوکسین لوکس</span>
                <p className="app-desc">{baseText.app}</p>
                <a className="app-dl-btn"  target="_blank" download={true} href={process.env.REACT_APP_MAIN+'/apkfiles/app-release.v0.1.apk'} >
                    <img src={Download} alt="Download" className="app-dl-icon"/>
                      دانلود اپلیکیشن اندروید
                </a>
            </div>
            {/* <Garanty classname={'app-garanty'} title='چرا لوکسین لوکس ؟'/> */}
            
        </StyleApp>
    )
}
export default Application